import apis from "../../core/apis.js";

class ScheduleResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.schedule).get(options);
  }

  get(id) {
    return this.$resource(apis.schedule + id).get();
  }

  post(item) {
    return this.$resource(apis.schedule).save(item);
  }

  reflect(id, item) {
    return this.$resource(apis.schedule + id + "/reflect").save(item);
  }

  update(id, item) {
    return this.$resource(apis.schedule + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  delete(id) {
    return this.$resource(apis.schedule + id).delete();
  }

  updateAction(id, name, item) {
    return this.$resource(apis.schedule + id + `/${name}`).save(item);
  }

  patchAction(id, item, name) {
    return this.$resource(apis.schedule + id + `/${name}`, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  resetPricingParameters(id) {
    return this.$resource(
      apis.schedule + id + "/reset_pricing_parameters",
      null,
      { update: { method: "PATCH" } }
    ).update();
  }

  refreshPet(id) {
    return this.$resource(
      `${apis.schedule}${id}/update_predicted_end_time`,
      null,
      {
        update: { method: "PATCH" },
      }
    ).update();
  }
}

export default ScheduleResource;



// WEBPACK FOOTER //
// ./src/resources/schedule/schedule.resource.js